// src/features/reporting/Routes.jsx
import { Route } from 'react-router-dom';
import ProtectedRoute from '../auth/Utils/ProtectedRoute';
import ReportListPage from './pages/ReportListPage';
import StockValuePage from './pages/inventory/StockValuePage';
import AbcAnalysisPage from './pages/inventory/AbcAnalysisPage';
import CoRemovalPage from './pages/inventory/CoRemovalPage';

export const ReportingRoutes = () => (
  <Route path="reports">
    <Route
      index
      element={
        <ProtectedRoute requiredScope="report:generate">
          <ReportListPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="stock-value"
      element={
        <ProtectedRoute requiredScope="inventory:cost:read">
          <StockValuePage />
        </ProtectedRoute>
      }
    />
    <Route
      path="abc"
      element={
        <ProtectedRoute requiredScope="inventory:cost:read">
          <AbcAnalysisPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="co-removal"
      element={
        <ProtectedRoute requiredScope="inventory:stock:read">
          <CoRemovalPage />
        </ProtectedRoute>
      }
    />
  </Route>
);
